import { useQuery } from "@tanstack/react-query";
import { gqlReqNext } from "~utils/api/gql-req/next";
import {
	GetCurrentPartnerQuery,
	GetCurrentPartnerQueryVariables,
} from "~/types/__generated/gql/graphql";

const query = /* GraphQL */ `
	query GetCurrentPartner {
		getCurrentPartner {
			id
			cognitoId
			companyName
			firstName
			lastName
			contactEmail
			isSuspended
			recurlyAccountCode
			recurlyCouponCode
			_recurlyAccountInfo {
				hostedToken
				paymentMethod {
					cardType
					lastFour
					expMonth
					expYear
				}
			}
			_recurlyCouponCodeInfo {
				id
				code
				name
				value {
					kind
					percent
					amount
					currency
				}
			}
			createdAt
			updatedAt
		}
	}
`;

export type CurrentPartner = GetCurrentPartnerQuery["getCurrentPartner"] & {
	_recurlyCouponCodeInfo?: {
		id: string;
		code: string;
		name: string;
		value: {
			kind: "percent" | "fixed";
			percent?: number | null;
			amount?: number | null;
			currency?: string | null;
		};
	} | null;
};

export const getCurrentPartnerQueryKey = () => ["getCurrentPartner"];

export const getCurrentPartnerQueryFn = async (signal?: AbortSignal) => {
	return gqlReqNext<GetCurrentPartnerQuery, GetCurrentPartnerQueryVariables>({
		query,
		signal,
	});
};

/**
 * @deprecated Avoid using this directly, access current partner via PartnerAuthContext instead.
 */
export const useGetCurrentPartner = (enabled = true) => {
	return useQuery({
		queryKey: getCurrentPartnerQueryKey(),
		queryFn: ({ signal }) => getCurrentPartnerQueryFn(signal),
		enabled,
	});
};
